import { render, staticRenderFns } from "./ModalBGroups.vue?vue&type=template&id=b7c7d1aa&scoped=true"
import script from "./ModalBGroups.vue?vue&type=script&lang=js"
export * from "./ModalBGroups.vue?vue&type=script&lang=js"
import style0 from "./ModalBGroups.vue?vue&type=style&index=0&id=b7c7d1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c7d1aa",
  null
  
)

export default component.exports